import '@mdi/font/css/materialdesignicons.css'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import colors from 'vuetify/lib/util/colors'
import { pl } from 'vuetify/locale'
// import '@/assets/mdi-public.css'

export default createVuetify({
    components,
    directives,
    defaults: {
        VSwitch: {
            color: 'primary', // Checked/active color
            baseColor: 'grey' // Unchecked/base color (track/outline)
        },
        VCheckbox: {
            color: 'primary'
        },
        VSelect: {
            VCheckboxBtn: {
                color: 'primary'
            }
        }
    },
    theme: {
        defaultTheme: 'legacy',
        options: {
            customProperties: true
        },
        themes: {
            legacy: {
                dark: false,
                colors: {
                    background: colors.grey.lighten5,
                    primary: colors.blue.base,
                    secondary: '#e04512',
                    accent: colors.blue.base,
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FFC107'
                }
            }
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi }
    },
    locale: {
        locale: 'pl',
        messages: { pl }
    }
})
